/** Path of the app-preview root forwarder, served from the origin root. */
export const PREVIEW_AUTH_FORWARD_PATH = '/auth-forward'

/**
 *
 */
export function previewAuthRedirectUri(): string {
  // nosemgrep: no-window-location-origin-route-string -- Auth0 redirect_uri, not an in-app route
  return new URL(PREVIEW_AUTH_FORWARD_PATH, window.location.origin).href
}

/** sessionStorage key recording the PR's return base path (e.g. `/123/thymebox/`). */
export const PREVIEW_RETURN_KEY = 'preview_return'

/**
 * True when running inside a PR preview deploy. Previews are the only build
 * with a non-root base path, so `BASE_URL !== '/'` uniquely identifies them.
 */
export function isPreview(): boolean {
  return import.meta.env.BASE_URL !== '/'
}

/**
 * Record the current base path so the app-preview root forwarder
 * (`/auth-forward`) can route the completed login back into this PR's
 * base-pathed SPA. Safe to call repeatedly (idempotent).
 *
 * Uses `sessionStorage` (per-tab), NOT a cookie: every preview shares one
 * origin, so a `path=/` cookie is a single slot that concurrent logins in
 * other tabs would clobber (mis-routing you to the wrong PR). sessionStorage
 * is scoped to this tab and survives the same-tab redirect chain out to Auth0
 * and back, so each login keeps its own return path.
 */
export function setPreviewReturnPath(): void {
  sessionStorage.setItem(PREVIEW_RETURN_KEY, import.meta.env.BASE_URL)
}
